import Lottie from "react-lottie";
import { Link } from "react-router-dom";
import success from "assets/lotties/successGreen.json";
import { defaultOptions } from "assets/lotties/constants";
import { routes } from "constants/index";
import { SchoolSection } from "../components/SchoolSection";
import { SectionTitle } from "../components/SectionTitle";
import { useSchoolLocal } from "../useSchoolLocal";

export const FormSuccessPage = () => {
  const { t } = useSchoolLocal();

  return (
    <SchoolSection contentClassName="flex flex-col items-center py-12 text-center md:py-16">
      <div className="h-[200px] w-[200px] md:h-[260px] md:w-[260px]">
        <Lottie
          options={defaultOptions({ animationData: success })}
          height="100%"
          width="100%"
        />
      </div>
      <SectionTitle className="mt-4">{t("connect.success.title")}</SectionTitle>
      <Link
        to={routes.school}
        className="mt-8 rounded-xl bg-[#4242CE] px-6 py-3 text-[16px] font-medium text-white transition-colors duration-200 hover:bg-[#4242CE]/90"
      >
        {t("buttons.backToSchoolPage")}
      </Link>
    </SchoolSection>
  );
};
